import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SharedModule } from '../shared/shared.module';
import { NftStakingRoutingModule } from './nft-staking-routing.module';
import { NftStakingComponent } from './nft-staking.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';

@NgModule({
  declarations: [NftStakingComponent, TermsAndConditionsComponent],
  imports: [
    CommonModule,
    NftStakingRoutingModule,
    TranslocoModule,
    SharedModule,
    ModalModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule,
  ],
})
export class NftStakingModule {}
